import { css } from '@microsoft/fast-element';
export const maxheight = 230;
export const multiselectStyles = css `
  .root {
    position: relative;
    width: inherit;
    min-width: 250px;
  }

  .control {
    cursor: pointer;
    position: relative;
    display: flex;
    align-items: center;
    width: 100%;
    border-radius: calc(var(--control-corner-radius) * 1px);
  }

  #display-field {
    width: 100%;
    cursor: pointer;
    color: rgb(241 241 241);
    min-height: 40px;
    padding: 0 calc(var(--design-unit) * 2.25px);
    border-width: 0;
    background: var(--neutral-fill-input-rest);
    border-radius: calc(var(--control-corner-radius) * 1px);
  }

  #display-field[disabled] {
    cursor: not-allowed;
    opacity: 30%;
  }

  #display-field:focus {
    outline: 1px solid var(--accent-fill-rest);
    background: var(--neutral-fill-input-rest);
    border-style: none;
    box-shadow: none;
  }

  #display-field:hover:not(:focus):not([disabled]) {
    outline: 1px solid rgb(231 232 232);
  }

  button {
    pointer-events: none;
  }

  .indicator {
    position: absolute;
    left: calc(100% - 26px);
    padding: 0;
    cursor: pointer;
  }

  #arrow-icon {
    width: 16px;
    fill: white;
    transform: rotate(0deg);
    transition: transform 0.2s linear 0s;
  }

  #arrow-icon.flipped {
    transform: rotate(180deg);
  }

  .disabled-svg {
    pointer-events: none;
    opacity: 30%;
  }

  .options {
    display: flex;
    flex-direction: column;
    position: absolute;
    height: max-content;
    overflow-y: hidden;
    margin-top: 5px;
    border: 1px solid rgba(46 51 57 / 100%);
    border-radius: 4px;
    background: var(--neutral-fill-input-rest);
    width: 100%;
    max-height: 0;
    visibility: hidden;
    transition:
      max-height 0.4s ease 0s,
      visibility 0.4s ease 0s;
    z-index: 999;
  }

  .position-above {
    bottom: 100%;
  }

  .checkbox-container {
    display: flex;
    flex-direction: column;
    overflow-y: scroll;
    scrollbar-width: thin;
    scrollbar-color: rgb(46 48 53) rgb(31 33 38);
  }

  .checkbox-container zero-checkbox {
    min-width: fit-content;
  }

  .checkbox-container zero-checkbox[disabled],
  .checkbox-container foundation-checkbox[disabled] {
    cursor: not-allowed;
  }

  #filter-search {
    padding: 5px;
  }

  ::-webkit-scrollbar {
    width: 12px;
  }

  ::-webkit-scrollbar-track {
    background: rgb(31 33 38);
  }

  ::-webkit-scrollbar-thumb {
    width: 8px;
    border-radius: 10px;
    box-shadow: inset 0 0 6px rgba(0 0 0 / 30%);
    background-color: rgb(46 48 53);
    border: 3px solid rgb(31 33 38);
  }

  .visible {
    visibility: visible;
    max-height: ${maxheight.toString()}px;
  }

  ::slotted(foundation-checkbox),
  foundation-checkbox {
    border-bottom: 1px solid rgb(46 48 52);
    padding: 5px 0 5px 5px;
    margin: 0;
  }

  ::slotted(foundation-checkbox:hover),
  foundation-checkbox:hover {
    background-color: rgb(45 47 51);
    cursor: pointer;
  }

  ::slotted(foundation-checkbox)::part(label),
  foundation-checkbox::part(label) {
    overflow-x: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .label {
    display: block;
    cursor: pointer;
    font-size: var(--type-ramp-base-font-size);
    line-height: var(--type-ramp-base-line-height);
    font-style: normal;
    margin: calc(var(--design-unit) * 2px) 0;
  }

  .label-hidden {
    display: none;
  }
`;
